import nanostyled from 'nanostyled';

export const Container = nanostyled('div', {
  spacing: null,
  base: 'col-count-1 md:col-count-2 col-gap-xl',
});
